import { Text } from '@user-portal/wikr-components';
import { Trans } from 'react-i18next';
import { toast } from 'react-toastify';

import { AUTO_CLOSE_DURATION, NOTIFY_STATUSES } from 'constants/notifications';

import { CheckCircle, ErrorIcon } from 'components/Icon';

export type ShowNotifyType = {
    dataLocator?: string;
    message: string;
    status?: NOTIFY_STATUSES;
    autoClose?: number;
    values?: { [key: string]: string | number };
};

export const Message = ({
    message,
    locator,
    values,
}: {
    message: string;
    locator?: string;
    values?: { [key: string]: string | number };
}) => (
    <div data-locator={locator}>
        <Text type="small-text" color="text-main">
            <Trans i18nKey={message} values={values} />
        </Text>
    </div>
);

const showNotify = ({
    dataLocator,
    message,
    status = NOTIFY_STATUSES.DEFAULT,
    autoClose = AUTO_CLOSE_DURATION,
    values,
}: ShowNotifyType) => {
    if (status === NOTIFY_STATUSES.SUCCESS) {
        return toast.success(<Message message={message} values={values} locator={dataLocator || 'successAlertbox'} />, {
            icon: <CheckCircle />,
            autoClose,
        });
    }
    if (status === NOTIFY_STATUSES.ERROR) {
        return toast.error(<Message message={message} values={values} locator={dataLocator || 'failedAlertbox'} />, {
            icon: <ErrorIcon />,
            autoClose,
        });
    }

    return toast(<Message message={message} values={values} locator={dataLocator || 'alertbox'} />, {
        autoClose,
    });
};

export default showNotify;
